import { render, staticRenderFns } from "./pushtotal.vue?vue&type=template&id=124f3fde&scoped=true&"
import script from "./pushtotal.vue?vue&type=script&lang=js&"
export * from "./pushtotal.vue?vue&type=script&lang=js&"
import style0 from "./pushtotal.vue?vue&type=style&index=0&id=124f3fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f3fde",
  null
  
)

export default component.exports